<template>
  <div class="authors-page">
    <div class="authors-inner">
      <h1 class="page-title">{{ $t("authors.title") }}</h1>

      <!-- Sort -->
      <div class="sort-bar">
        <span class="sort-label">{{ $t("authors.sortLabel") }}</span>
        <el-radio-group v-model="sortBy" size="small">
          <el-radio-button label="stroke">{{ $t("authors.sortStroke") }}</el-radio-button>
          <el-radio-button label="pinyin">{{ $t("authors.sortPinyin") }}</el-radio-button>
          <el-radio-button label="publications">{{ $t("authors.sortPublications") }}</el-radio-button>
        </el-radio-group>
      </div>

      <!-- Author Grid -->
      <el-row :gutter="24" class="author-grid">
        <el-col :span="6" v-for="(author, index) in authorList" :key="index">
          <div class="author-card" @click="goToAuthorDetail(author)">
            <div class="author-avatar">
              <img v-if="author.avatar" :src="author.avatar" :alt="author.name" />
              <div v-else class="avatar-placeholder">
                <i class="el-icon-user"></i>
              </div>
            </div>
            <div class="author-name">{{ author.name }}</div>
          </div>
        </el-col>
      </el-row>

      <!-- Pagination -->
      <div class="pagination-wrapper">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthorsPage",
  data() {
    return {
      sortBy: "stroke",
      currentPage: 1,
      pageSize: 16,
      total: 80,
    };
  },
  computed: {
    authorList() {
      const names = [
        "王小明", "李金強", "張三丰", "趙四", "王小明", "李金強", "張三丰", "趙四",
        "王小明", "李金強", "張三丰", "趙四", "王小明", "李金強", "張三丰", "王小明",
      ];
      return names.map((name, i) => ({
        id: i + 1,
        name,
        avatar: null,
      }));
    },
  },
  methods: {
    handlePageChange() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    goToAuthorDetail(author) {
      this.$router.push({ path: `/author/${author.id}` });
    },
  },
};
</script>

<style lang="scss" scoped>
.authors-page {
  flex: 1;
  padding: 40px 0;
}

.authors-inner {
  max-width: $max-width;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 22px;
  font-weight: 700;
  color: $primary-orange;
  margin-bottom: 20px;
}

.sort-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  font-size: 13px;
  color: $text-gray;
}

.author-grid {
  .el-col {
    margin-bottom: 24px;
  }
}

.author-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 16px;
  border-radius: 8px;
  transition: all 0.2s;

  &:hover {
    background: $bg-light;
    transform: translateY(-2px);
  }
}

.author-avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 10px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .avatar-placeholder {
    width: 100%;
    height: 100%;
    background: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 40px;
      color: #ccc;
    }
  }
}

.author-name {
  font-size: 14px;
  color: $text-dark;
  font-weight: 500;
  text-align: center;
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
